type ReportRequestInput = {
  query?: unknown;
  email?: unknown;
  timezone?: unknown;
};

export const normalizeReportRequestBody = (value: ReportRequestInput) => {
  return {
    query: typeof value.query === 'string' ? value.query : '',
    email: typeof value.email === 'string' ? value.email : '',
    timezone: typeof value.timezone === 'string' ? value.timezone : '',
  };
};
